import './payment-method-selection.scss';
import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import { slug } from 'researcher/helpers/slug';
var PaymentMethodSelectionButton = function PaymentMethodSelectionButton(_ref) {
  var paymentMethod = _ref.paymentMethod,
    localizationIsoCode = _ref.localizationIsoCode,
    paymentMethodId = _ref.paymentMethodId,
    selectionDisabled = _ref.selectionDisabled,
    onClick = _ref.onClick;
  var _useTranslate = useTranslate(),
    translationExists = _useTranslate.translationExists;
  var headerTerm = slug("".concat(paymentMethod.name, " header ").concat(localizationIsoCode));
  var subHeaderTerm = slug("".concat(paymentMethod.name, " subheader ").concat(localizationIsoCode));
  return /*#__PURE__*/React.createElement("div", {
    className: "button-wrapper",
    key: paymentMethod.id
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "d-block btn btn-link btn-squared text-decoration-none ".concat(paymentMethodId === paymentMethod.id ? 'active' : ''),
    disabled: selectionDisabled,
    onClick: onClick,
    "data-cy": paymentMethod.name
  }, /*#__PURE__*/React.createElement(T, {
    source: translationExists(headerTerm) ? headerTerm : paymentMethod.name
  }), translationExists(subHeaderTerm) ? /*#__PURE__*/React.createElement("div", {
    className: "payment-method-subheader"
  }, /*#__PURE__*/React.createElement(T, {
    source: subHeaderTerm
  })) : null));
};
export default PaymentMethodSelectionButton;